import React from 'react'
import { useShadowOnTopScroll } from './hooks/useShadowOnTopScroll'

export const StickyHeaderOnTopScroll: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { stickyEl1Ref } = useShadowOnTopScroll()

  return <div ref={stickyEl1Ref}>{children}</div>
}
